<template lang="pug">
  DataTablePage(
    mainColumn="name"
    longColumn="address"
    resource="base/waterUser"
    title="区本明细"
    label="区本"
    labelName="name"
    :toolbar="toolbar"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :filterByAlways="filterByAlways"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { toolbarBack } from '@/containers/DataTablePage/toolbar'
import fullColumns from '@/containers/meterReading/fullColumns'

export default {
  name: 'WaterUser',
  components: {
    DataTablePage
  },
  data () {
    return {
      toolbar: [toolbarBack],
      filterByAlways: [{
        name: 'bookId',
        type: 'eq',
        value: this.$route.params.id
      }],
      tableInitList: ['orgParentId', 'readingUserId', 'areaCode', 'bookCode', 'pageCode', 'code', 'name', 'address', 'linkTel', 'waterMeterLocation', 'barcode', 'caliberDigit', 'waterMeterOrigin', 'outerCode', 'chargeStandard', 'readingCycle', 'avgWaterUse', 'feeTypeId', 'rubTypeId'],
      tableFullList: ['orgParentId', 'readingUserId', 'areaCode', 'bookCode', 'pageCode', 'code', 'name', 'address', 'linkTel', 'waterMeterLocation', 'barcode', 'caliberDigit', 'waterMeterOrigin', 'outerCode', 'chargeStandard', 'readingCycle', 'avgWaterUse', 'feeTypeId', 'rubTypeId'],
      filterInitList: ['orgParentId', 'readingUserId'],
      filterFullList: ['orgParentId', 'readingUserId'],
      columns: {
        ...fullColumns
      //   bookCode: {
      //     label: '区本号',
      //     width: 80
      //   },
      //   bookName: {
      //     label: '区本名称',
      //     width: 110
      //   },
      //   paymentCode: {
      //     label: '缴费号',
      //     width: 110,
      //     filter: {
      //       type: 'input',
      //       width: 110,
      //       like: true
      //     }
      //   },
      //   code: {
      //     label: '户号',
      //     width: 110,
      //     filter: {
      //       type: 'input',
      //       width: 140,
      //       like: true
      //     }
      //   },
      //   name: {
      //     label: '户名',
      //     width: 140,
      //     filter: {
      //       type: 'input',
      //       like: true
      //     }
      //   },
      //   address: {
      //     label: '地址',
      //     width: 140,
      //     filter: {
      //       type: 'input',
      //       like: true
      //     }
      //   },
      //   waterNatureId: {
      //     label: '用水性质',
      //     width: 100,
      //     type: 'select',
      //     relation: 'waterNature',
      //     filter: {
      //       type: 'select',
      //       width: 120
      //     }
      //   },
      //   caliber: {
      //     label: '水表口径',
      //     width: 96,
      //     type: 'select',
      //     relation: 'caliber',
      //     filter: {
      //       type: 'select',
      //       width: 100
      //     }
      //   },
      //   outerCode: {
      //     label: '水表外码',
      //     width: 100
      //   },
      //   barcode: {
      //     label: '水表条形码',
      //     width: 120
      //   },
      //   meterRange: {
      //     label: '水表量程',
      //     width: 100
      //   },
      //   linkName: {
      //     label: '联系人名称',
      //     width: 100
      //   },
      //   linkAddress: {
      //     label: '联系人地址',
      //     width: 100
      //   },
      //   linkPhone: {
      //     label: '联系人手机',
      //     width: 100
      //   },
      //   linkTel: {
      //     label: '联系人电话',
      //     width: 100
      //   },
      //   installTime: {
      //     label: '安装时间',
      //     width: 100
      //   }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// WaterUser.vue?580a431c